// import request from '@/utils/request'
import axios from '@/http/api'

//3.7.3 发送设备控制请求
export const seedTempControl = data => {
  return axios({
    url: "/manageGateway/equipmentManageController/seedTempControl",
    method: "post",
    data
  });
};

//selectEquipmentIotTemplate //3.2.18 获取设备IOT模板信息
export const selectEquipmentIotTemplate = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectEquipmentIotTemplate',
    method: 'post',
    data
  })
}

//updateIotTemplate //3.2.12 更新IOT模板信息
export const updateIotTemplate = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateIotTemplate',
    method: 'post',
    data
  })
}

//updateIotInfoToEquipment //3.2.12 更新IOT配置信息到其他设备
export const updateIotInfoToEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateIotInfoToEquipment',
    method: 'post',
    data
  })
}

//selectEquipmentIotMsg //3.2.17 获取设备IOT信息
export const selectEquipmentIotMsg = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectEquipmentIotMsg',
    method: 'post',
    data
  })
}

//getPublicCloud //3.1.12 获取工程私有云设置
export const getPublicCloud = data => {
  return axios({
    url: '/manageGateway/userInfoController/getPublicCloud',
    method: 'post',
    data
  })
}

//selectEquipmentList //分页获取设备列表
export const selectEquipmentList = data => {
    return axios({
    url: '/manageGateway/equipmentManageController/selectEquipmentList',
    method: 'post',
    data
  })
}

//insertBatchEquipment //批量添加设备
export const insertBatchEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/insertBatchEquipment',
    method: 'post',
    data
  })
}

//updateOneEquipment //修改设备信息
export const updateOneEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateOneEquipment',
    method: 'post',
    data
  })
}

//deleteEquipment //批量删除设备
export const deleteEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/deleteEquipment',
    method: 'post',
    data
  })
}

//deleteEquipment //批量修改设备信息
export const updateEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateEquipment',
    method: 'post',
    data
  })
}

//updateInterfaceName //批量修改设备接口名称
export const updateInterfaceName = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateInterfaceName',
    method: 'post',
    data
  })
}
//selectDefaultInterfaceName //获取默认设备接口名称
export const selectDefaultInterfaceName = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectDefaultInterfaceName',
    method: 'post',
    data
  })
}

//3.2.22 批量修改设备接口名称
export const updateEquipmentInterfaceName = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateEquipmentInterfaceName',
    method: 'post',
    data
  })
}

//3.2.23 分页获取设备接口名称列表
export const selectInterfaceName = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectInterfaceName',
    method: 'post',
    data
  })
}

//importProjector //导入投影仪
export const importProjector = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/importProjector',
    method: 'post',
    data
  })
}

//selectDataListByType //获取投影仪数据列表
export const selectDataListByType = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectDataListByType',
    method: 'post',
    data
  })
}


//selectDataBrand //3.3.7 获取数据所有品牌
export const selectDataBrand = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectDataBrand',
    method: 'post',
    data
  })
}
//selectDataModelByBrand //3.3.8 根据品牌获取型号
export const selectDataModelByBrand = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectDataModelByBrand',
    method: 'post',
    data
  })
}
//selectDataByBrandAndModel //3.3.9 根据品牌和型号获取数据信息
export const selectDataByBrandAndModel = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectDataByBrandAndModel',
    method: 'post',
    data
  })
}
//insertDataInfo //3.3.3 批量添加数据
export const insertDataInfo = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/insertDataInfo',
    method: 'post',
    data
  })
}
//updateIRInfo //3.2.10 发送空调调试信息
export const updateIRInfo = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateIRInfo',
    method: 'post',
    data
  })
}

//updateStartInfoToEquipment //3.2.9 更新配置信息到其他设备
export const updateStartInfoToEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateStartInfoToEquipment',
    method: 'post',
    data
  })
}
//3.8.11 获取用户组织集控树
export  const selectUserOrgEquipmentTree = data => {
  return axios({
    url:'/manageGateway/equipmentController/selectUserOrgEquipmentTree',
    method: 'post',
    data
  })
}
//
export  const selectSchoolUser = data => {
  return axios({
    url:'/manageGateway/userInfoController/selectSchoolUser',
    method: 'post',
    data
  })
}
// //3.2.14 更新用户设备关联信息
// export const updateUserEquipment = data => {
//   return axios({
//     url: '/manageGateway/equipmentManageController/updateUserEquipment',
//     method: 'post',
//     data
//   })
// }
//selectOrgAndUserTree //获取用户与组织树
export const selectOrgAndUserTree = data => {
  return axios({
    url: '/manageGateway/organizationController/selectOrgAndUserTree',
    method: 'post',
    data
  })
}


//3.4.12 获取组织关联的所有用户信息
export const selectUserInfoIdByOrgId = data => {
  return axios({
    url: '/manageGateway/usersController/selectUserInfoIdByOrgId',
    method: 'post',
    data
  })
}
//3.2.10 更新配置信息到其他设备
export const updateLinkageInfoToEquipment = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateLinkageInfoToEquipment',
    method: 'post',
    data
  })
}

export const selectIrDataList = data => {
  return axios({
    url: 'manageGateway/equipmentManageController/selectIrDataList',
    method: 'post',
    data
  })
}
export const selectEquipmentRunInfo = data => {
  return axios({
    url: 'manageGateway/equipmentManageController/selectEquipmentRunInfo',
    method: 'post',
    data
  })
}

//4.7.1 添加或修改自动任务
export const insertAndUpdateAutoTask = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/insertAndUpdateAutoTask',
    method: 'post',
    data
  })
}

//4.7.2 修改自动任务状态
export const updateAutoTaskState = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateAutoTaskState',
    method: 'post',
    data
  })
}

//4.7.3 删除自动任务
export const deleteAutoTask = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/deleteAutoTask',
    method: 'post',
    data
  })
}

//4.7.4 分页获取自动任务
export const selectAutoTask = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectAutoTask',
    method: 'post',
    data
  })
}

// 分页获取联动任务
export const selectLinkTask = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/selectLinkTask',
    method: 'post',
    data
  })
}

// 修改联动任务状态
export const updateLinkTaskState = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/updateLinkTaskState',
    method: 'post',
    data
  })
}

// 添加或修改联动任务
export const insertAndUpdateLinkTask = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/insertAndUpdateLinkTask',
    method: 'post',
    data
  })
}

// 删除联动任务
export const deleteLinkTask = data => {
  return axios({
    url: '/manageGateway/equipmentManageController/deleteLinkTask',
    method: 'post',
    data
  })
}

//3.7.6 获取设备IR红外码信息
export const selectControlIRInfo = data => {
  return axios({
    url: "/manageGateway/equipmentController/selectControlIRInfo",
    method: "post",
    data
  });
};





// WEBPACK FOOTER //
// ./src/api/equipmentMge.js